const settingsSchema = {
  $id: "/settings",
  type: "object",
  properties: {},
  required: [],
  additionalProperties: true,
};

export default settingsSchema;
